"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _icon = _interopRequireDefault(require("../icon"));

var _spinner = _interopRequireDefault(require("../spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.variant || "common"));
      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.size || "medium"));

      var style = _objectSpread({}, this.getStyle());

      if (this.props.color) {
        style.color = this.props.color;
      }

      this.props.spaced && this.addClass("lth-is-spaced");
      this.props.monochrome && this.addClass("lth-is-monochrome");

      if (this.props.ingroup) {
        this.addClass("lth-is-ingroup");
        if (this.props.position === "first") this.addClass("lth-is-groupFirst");else if (this.props.position === "last") this.addClass("lth-is-groupLast");else this.addClass("lth-is-groupInner");
      }

      var platform = this.props.platform;

      if (platform) {
        this.addClass("platform-".concat(platform));
        this.addClass("variant-".concat(this.props.variant || "common"));
      }

      var iconLeft = /*#__PURE__*/_react.default.createElement("div", null); // grid cell filler


      if (this.props.iconLeft) {
        iconLeft = /*#__PURE__*/_react.default.createElement(_icon.default, {
          icon: this.props.iconLeft,
          className: this.constructor.BASE_CLASS + "__icon",
          size: 20
        });
        this.addClass("lth-has-icon");
      }

      var iconRight = /*#__PURE__*/_react.default.createElement("div", null); // grid cell filler


      if (this.props.iconRight || this.props.icon) {
        iconRight = /*#__PURE__*/_react.default.createElement(_icon.default, {
          icon: this.props.iconRight || this.props.icon,
          className: this.constructor.BASE_CLASS + "__icon",
          size: 20
        });
        this.addClass("lth-has-icon");
      }

      var ButtonTag = this.props.href ? "a" : "button";

      var label = /*#__PURE__*/_react.default.createElement("div", null);

      var buttonLabel = this.props.label === null ? null : this.props.children || this.props.label || this.props.text || "Button label";

      if (buttonLabel) {
        label = /*#__PURE__*/_react.default.createElement("div", {
          className: this.constructor.BASE_CLASS + "__label"
        }, buttonLabel);
      } else {
        this.addClass("lth-is-icononly");
      }

      var props = {
        className: this.getClassNames(),
        style: style,
        type: this.props.type,
        href: this.props.href,
        tabIndex: this.props.disabled ? -1 : 0,
        target: this.props.target,
        onClick: this.props.onClick,
        ref: this.ref
      };
      var spinner = this.props.loading ? /*#__PURE__*/_react.default.createElement(_spinner.default, null) : null;
      return /*#__PURE__*/_react.default.createElement(ButtonTag, props, iconLeft, label, iconRight, spinner);
    }
  }]);

  return Button;
}(_component.default);
/*---------------------------------------------*/


exports.default = Button;

_defineProperty(Button, "BASE_CLASS", "lth-c-button");

Button.METADATA = {
  name: "Button",
  description: 'Buttons are used primarily for actions, such as "Add", "Close", "Cancel", or "Save". Plain buttons, which look similar to links, are used for less important or less commonly used actions, such as "view shipping settings".',
  props: [{
    name: "variant",
    type: "string",
    default: "common",
    description: "Choose which variant of button to display",
    options: [{
      value: "primary",
      description: "For the principal call to action on the page."
    }, {
      value: "common",
      description: "For secondary actions on each page."
    }, {
      value: "flat",
      description: "When an action does not require primary dominance on the page."
    }, {
      value: "inverse",
      description: ""
    }, {
      value: "outline",
      description: "When an action does not require primary dominance on the page."
    }, {
      value: "danger",
      description: ""
    }, {
      value: "warning",
      description: ""
    }]
  }, {
    name: "type",
    type: "string",
    options: [{
      value: "submit"
    }, {
      value: "reset"
    }, {
      value: "button"
    }]
  }, {
    name: "size",
    type: "string",
    default: "medium",
    description: "Choose the size of button",
    options: [{
      value: "medium",
      description: "medium sized button."
    }, {
      value: "large",
      description: "large sized button."
    }, {
      value: "small",
      description: "small sized button."
    }]
  }, {
    name: "loading",
    type: "boolean",
    default: false
  }, {
    name: "fullwidth",
    type: "boolean",
    default: false
  }, {
    name: "disabled",
    type: "boolean",
    default: false,
    description: "Show the component in disabled state."
  }, {
    name: "forcehover",
    type: "boolean",
    default: false,
    description: "Force hover state."
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false,
    description: "Force focus state."
  }, {
    name: "label",
    type: "string",
    description: "Label displayed in the button",
    default: "Button Label"
  }, {
    name: "iconLeft",
    type: "string",
    description: "Icon displayed on the left side of the button"
  }, {
    name: "iconRight",
    type: "string",
    description: "Icon displayed on the right side of the button"
  }, {
    name: "href",
    type: "string",
    description: "Button link"
  }, {
    name: "target",
    type: "string",
    options: [{
      value: "_self",
      label: "Current tab"
    }, {
      value: "_blank",
      label: "New tab"
    }, {
      value: "_parent",
      label: "Parent window"
    }, {
      value: "_top",
      label: "Top window"
    }]
  }, {
    name: "onClick",
    type: "function",
    description: "Callback function called after the button is clicked"
  }]
};